// Hangfire run-state classification for the recurring grid's poll predicate (sc-100769).

/**
 * Non-terminal Hangfire states, as an **allowlist**. Everything else — including `null` for a job that
 * has never run (most are registered `Cron.Never()`) and any state this list does not name — counts as
 * terminal, so an unrecognized value can never leave the page polling forever.
 */
export const NON_TERMINAL_JOB_STATES = ["Enqueued", "Processing", "Scheduled", "Awaiting"] as const;

/** True only for a state on the allowlist above. `null` and anything unrecognized are TERMINAL. */
export function isNonTerminalState(state: string | null | undefined): boolean {
  if (!state) return false;
  return (NON_TERMINAL_JOB_STATES as readonly string[]).includes(state);
}

/**
 * The recurring page's poll predicate: keep refreshing while any row is still non-terminal OR any row
 * is still pending from a trigger this page issued.
 *
 * The pending disjunct is load-bearing, not belt-and-braces: immediately after a trigger the fetched
 * state is still the *previous* run's terminal one, so a state-only predicate would never start
 * polling — which is the defect this story exists to fix.
 *
 * It takes the pending map's SIZE rather than the map so this module imports nothing.
 */
export function shouldPoll(
  rows: readonly { last_job_state: string | null }[],
  pendingCount: number
): boolean {
  return pendingCount > 0 || rows.some((job) => isNonTerminalState(job.last_job_state));
}
